import { render, staticRenderFns } from "./swiper_list.vue?vue&type=template&id=168c8ace&scoped=true&"
import script from "./swiper_list.vue?vue&type=script&lang=js&"
export * from "./swiper_list.vue?vue&type=script&lang=js&"
import style0 from "./swiper_list.vue?vue&type=style&index=0&id=168c8ace&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "168c8ace",
  null
  
)

export default component.exports